/**
 * @author Kajabi, LLC <info@kajabi.com>
 * @license MIT
 */
import { Entity } from "@backstage/catalog-model";

export const CODE_DISPLAY_METADATA = "code";
export const EFF_ENV_ANNOTATION = "eff/env";
export const EFF_FF_ANNOTATION = "eff/ff";

export const useProjectEntity = (entity: Entity) => {
  return {
    code: entity.metadata?.[CODE_DISPLAY_METADATA] as string[],
    env: entity.metadata?.[EFF_ENV_ANNOTATION] as any[],
    ff: entity.metadata?.[EFF_FF_ANNOTATION] as any[],
  };
};
